import { Card, Tab, Tabs } from "@mui/material";
import PropTypes from "prop-types";
import React, { useState } from "react";
import AugmentationChart from "./AugmentationChart";
import TabPanel from "components/Users/TabPanel";

const tabs = [
  { index: 0, label: "Augmentation Index" },
  { index: 1, label: "Augmentation Pressure" },
  { index: 2, label: "SEVR" },
];
export default function AugmentationCard({ measures }) {
  const [tabIndex, setTabIndex] = useState(0);
  const handleTabChange = (_, newValue) => setTabIndex(newValue);
  return (
    <Card
      sx={{
        padding: "12px",
        borderRadius: "11px",
        border: "1px solid #E6E6EC",
        boxShadow: "none",
      }}
    >
      <Tabs
        value={tabIndex}
        onChange={handleTabChange}
        sx={{
          minHeight: 32,
          width: { xs: "auto", sm: "fit-content", lg: "fit-content" },
        }}
      >
        {tabs.map((tab) => (
          <Tab
            sx={{
              fontSize: "14px",
              fontWeight: 600,
              minHeight: 30,
              padding: 1,
              textTransform: "capitalize",
              color: "#00000099",
            }}
            key={tab.index}
            label={tab.label}
          />
        ))}
      </Tabs>
      <TabPanel value={tabIndex} index={0}>
        <AugmentationChart
          measures={measures}
          name="augmentation_index"
          label="Augmentation Index"
          risk={30}
          domain={[0, 100]}
        />
      </TabPanel>
      <TabPanel value={tabIndex} index={1}>
        <AugmentationChart
          measures={measures}
          name="augmentation_pressure"
          label="Augmentation Pressure"
          risk={10}
          unit="mmHg"
          domain={[0, 30]}
        />
      </TabPanel>
      <TabPanel value={tabIndex} index={2}>
        <AugmentationChart
          measures={measures}
          name="subendocardial_viability_ratio"
          label="SEVR"
          risk={100}
          domain={[0, 220]}
        />
      </TabPanel>
    </Card>
  );
}

AugmentationCard.propTypes = {
  measures: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
    })
  ),
};

AugmentationCard.defaultProps = {
  measures: [],
};
